import React from "react";
import { getFallbackBadge } from "../../api/newsFallback";

function NewsFallbackNotice({ message, source = "local", onRetry, retrying = false }) {
  if (!message) return null;

  return (
    <div className="cms-fallback-notice" role="status">
      <div className="cms-fallback-notice__content">
        <span className="cms-fallback-notice__badge">{getFallbackBadge(source)}</span>
        <span>{message}</span>
      </div>

      {onRetry && (
        <button
          type="button"
          className="cms-fallback-notice__retry"
          onClick={onRetry}
          disabled={retrying}
        >
          {retrying ? "Provjera..." : "Pokušaj ponovo"}
        </button>
      )}
    </div>
  );
}

export default NewsFallbackNotice;
